import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  marcas: [],
  isLoading: false,
};

const marcaVehiculoSelectorSlice = createSlice({
  name: "business/marcaVehiculo",
  initialState,
  reducers: {
    fetchMarcasVehiculosInited: {
      prepare: () => ({ payload: {} }),
      reducer: (state) => {
        state.marcas = [];
        state.isLoading = true;
      },
    },
    fetchMarcasVehiculosCompleted: {
      prepare: (response) => ({ payload: { response } }),
      reducer: (state, action) => {
        state.marcas = action.payload.response.map((item) => ({
          value: item,
          label: item,
        }));
        state.isLoading = false;
      },
    },
    fetchMarcasVehiculosFailed: {
      prepare: (error) => ({ payload: { error } }),
      reducer: (state) => {
        state.marcas = [];
        state.isLoading = false;
      },
    },
  },
});

const {
  fetchMarcasVehiculosInited,
  fetchMarcasVehiculosCompleted,
  fetchMarcasVehiculosFailed,
} = marcaVehiculoSelectorSlice.actions;

const fetchMarcasVehiculos = () => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(fetchMarcasVehiculosInited());
      const response = await services.api.getVehiclesMarcas();
      dispatch(fetchMarcasVehiculosCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(fetchMarcasVehiculosFailed(error));
    }
  };
};

export default marcaVehiculoSelectorSlice.reducer;
export {
  fetchMarcasVehiculos,
  fetchMarcasVehiculosInited,
  fetchMarcasVehiculosCompleted,
  fetchMarcasVehiculosFailed,
};
